<template>
  <div class="w-full">
    <div class="flex items-center">
      <span class="mr-5 text-base font-bold text-EXPONDO-black">{{ $t("all-categories") }}</span>
      <ClientDesktopOnly>
        <NavigationLink
          v-bind="shopAllButtonProps"
        />
      </ClientDesktopOnly>
    </div>
    <NavCategoryList
      class="list-none"
      :itemscope="hasSchema ? 'itemscope' : undefined"
      :itemtype="hasSchema ? SCHEMA_ITEM_TYPE.SITE_NAVIGATION_ELEMENT : undefined"
    >
      <NavCategoryListItem
        v-for="firstLevelCategory in firstLevelCategories"
        :key="firstLevelCategory.id || firstLevelCategory.slug"
        :has-schema="hasSchema"
        :should-set-first-level-category="true"
        :data-testid="CATEGORY_TEST_IDS.MAIN_CATEGORY_BUTTON"
        :category="firstLevelCategory"
        class="mb-3 bg-EXPONDO-white"
      />
    </NavCategoryList>
    <ClientMobileOnly class="mt-14">
      <NavigationLink
        v-bind="shopAllButtonProps"
      />
    </ClientMobileOnly>
  </div>
</template>

<script lang="ts">

import type { Category } from '~~/types/commercetools';
import { SCHEMA_ITEM_TYPE } from '~~/constants/seo';
import { ROUTES_INFORMATION, ROUTES } from '~~/constants/routes';
import { CATEGORY_TEST_IDS } from '~~/constants/categoriesTestIds';

export default defineComponent({
  name: 'NavMainCategories',

  props: {
    firstLevelCategories: {
      type: Array as PropType<Category[]>,
      default: () => {

        return [];

      },
    },
    hasSchema: {
      type: Boolean,
      default: false,
    },
  },
  setup(_props) {

    const i18n = useI18n();

    const shopAllButtonProps = {
      'is-primary': true,
      text: i18n.t('Shop All'),
      url: ROUTES_INFORMATION[ROUTES.SEARCH].SLUG,
      'data-testid': 'showAllProducts',
    };

    return {
      SCHEMA_ITEM_TYPE,
      CATEGORY_TEST_IDS,
      shopAllButtonProps,
    };

  },
});


</script>
